import React, { useState } from 'react'
import styles from './styles.module.scss'
import colorVariables from 'srcReact/assets/scss/global/base/_variables.scss'
import { isMobileScreen } from 'srcReact/helpers/utils'
import useLongPress from 'srcReact/helpers/hooks/useLongPress'
import Modal from 'srcReact/components/common2/Modal'
import { useTranslation } from 'react-i18next'
import TooltipWrapper from 'srcReact/components/common2/TooltipWrapper'
import UserNameTooltip from 'srcReact/components/common2/UserNameTooltip'
import LikePill from './LikePill'
import PromptUsersModal from '../PromptUsersModal'

export default function LikeWithCount({ id, entity, count, editable, onClick, isLiked }) {
  const { t } = useTranslation()
  const contentStyle = {
    background: colorVariables.darkgray,
    color: colorVariables.whitecolor,
    width: '9rem',
    height: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '0.5rem',
    padding: '0.25rem'
  }

  const [isUsersModalOpen, setIsUsersModalOpen] = useState(false)
  const [promptForModal, setPromptForModal] = useState(null)

  const showUserModal = (prompt) => {
    setIsUsersModalOpen(true)
    setPromptForModal(prompt)
  }
  const closeUserModal = () => {
    setIsUsersModalOpen(false)
    setPromptForModal(null)
  }

  const onLongPress = () => {
    if (count > 0) {
      setIsUsersModalOpen(true)
      setPromptForModal(entity)
    }
  }

  const onPress = () => {
    onClick()
  }

  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 500
  }

  const longPressEvent = useLongPress(onLongPress, onPress, defaultOptions)

  return (
    <React.Fragment>
      {isMobileScreen() ? (
        <button
          className={styles.likeButton}
          aria-label={t('global.clickForLike')}
          type='button'
          {...longPressEvent}
          disabled={editable && count === 0}>
          <LikePill count={count} variant={isLiked ? 'pink' : 'gray'} />
        </button>
      ) : (
        <TooltipWrapper
          disabled={count === 0}
          position='top center'
          contentStyle={contentStyle}
          content={<UserNameTooltip entity={entity} showModal={showUserModal} isPrompt={true} />}
          triggerElement={
            <button
              aria-label={t('global.clickForLike')}
              type='button'
              onClick={onClick}
              disabled={editable && count === 0}>
              <LikePill count={count} variant={isLiked ? 'pink' : 'gray'} />
            </button>
          }
        />
      )}

      {isUsersModalOpen && promptForModal?.prompt?.id === id && (
        <Modal
          title={promptForModal.prompt.question}
          titleCSS={styles.modalTitle}
          className='promptUsers'
          isOpen={isUsersModalOpen}
          handleClose={closeUserModal}>
          <PromptUsersModal users={promptForModal.users} prompt={promptForModal.prompt} closeModal={closeUserModal} />
        </Modal>
      )}
    </React.Fragment>
  )
}
